import React, {useState, useCallback} from "react";

import withStyles from '@material-ui/core/styles/withStyles';
import {
    Create,
    FormTab,
    Edit,
    TextInput,
    TabbedForm,
    AutocompleteInput,
    SelectInput,
    DateInput,
    TopToolbar,
    ReferenceInput,
    Toolbar, SaveButton, DeleteButton,
    useGetOne, Loading, NumberInput, TextField, ShowButton
} from 'react-admin';
import {makeStyles} from "@material-ui/core";
import ComboUnidadNegocio from "../componentes/ComboUnidadNegocio";



const useStyles = makeStyles((theme) => ({
    estado_encuadre: {display: 'inline-block', width: 200, marginLeft: 8},
    estado_encuadre_d: {display: 'inline-block', width: 800, marginLeft: 8},
}));

const ContratacionEstadoEdit = props => {
    const classes = useStyles();


    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            <ShowButton basePath={basePath} record={data}/>
        </TopToolbar>
    );

    const redirect = (basePath, id, data) => `/ContratacionEstado`;

    const CustomToolbar = props => (

        <Toolbar {...props}>
            <SaveButton
                label="Actualizar"
                transform={transform}
                submitOnEnter={false}
                disabled={props.pristine}
            />
            <DeleteButton undoable={false} redirect={redirect}/>
        </Toolbar>
    );
    const transform = data => {
        return {
            ...data
        }
    };

    const PostTitle = ({record}) => {
        return <span>Contratacion Estado: {record ? `${record.estado_encuadre}` : ''}</span>;
    };

    return (
        <Edit title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm
                redirect={redirect}
                toolbar={<CustomToolbar/>}
            >
                {/*Datos*/}
                <FormTab label="DATOS CONTRATACION ESTADO">

                    <TextInput
                        label="Código Contratacion Estado"
                        source="estado_encuadre"
                        formClassName={classes.estado_encuadre}
                        placeholder="Ingrese Código Contratacion Estado"
                        helperText="Código Contratacion Estado"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />
                    <br/>


                    <TextInput
                        label="Descripción Contratacion Estado"
                        source="estado_encuadre_d"
                        formClassName={classes.estado_encuadre_d}
                        placeholder="Ingrese Descripción Contratacion Estado"
                        helperText="Descripción Contratacion Estado"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>


                </FormTab>
            </TabbedForm>
        </Edit>
    )
};
export default ContratacionEstadoEdit;


